'use client';

import { Divider, Stack, Typography } from '@mui/material';

import { FormTextField } from '@/components/form/formTextField';

const CATALOG_NAME_RE = /^[a-z][a-z0-9_]{0,62}$/;

interface CatalogNameSectionProps {
  value: string;
  onChange: (value: string) => void;
}

export const CatalogNameSection = ({
  value,
  onChange,
}: CatalogNameSectionProps) => (
  <>
    <Stack gap='8px' maxWidth='540px'>
      <Typography variant='subtitle2' fontWeight={700}>
        Catalog Name
      </Typography>
      <FormTextField
        title=''
        size='small'
        placeholder='e.g., my_catalog'
        value={value}
        validation={{
          validateInput: (v) => v.trim() === '' || CATALOG_NAME_RE.test(v),
          errorMessage: () =>
            'Must start with a lowercase letter and contain only lowercase letters, digits, and underscores (max 63 characters)',
        }}
        onChange={(e) => onChange(e.target.value)}
      />
    </Stack>
    <Divider />
  </>
);

export { CATALOG_NAME_RE };
